const guarantee = () => {

    const pageGuaranteeGroupPluses = document.querySelectorAll('.guarantee.register-card .group .items .plus');
    if (pageGuaranteeGroupPluses) {
        pageGuaranteeGroupPluses.forEach(function (plus) {
            plus.addEventListener('click', function (evt) {
                evt.preventDefault();
                let input = plus.closest('.items').querySelector('.new:last-of-type');
                let inputNew = input.cloneNode(true);
                inputNew.querySelector('.num').innerHTML = parseInt(inputNew.querySelector('.num').innerHTML) + 1;
                plus.insertAdjacentElement('beforebegin', inputNew);
            });
        });
    }
    const pageGuaranteeGroupRemoves = document.querySelectorAll('.guarantee.register-card .group .items .remove');
    if (pageGuaranteeGroupRemoves) {
        pageGuaranteeGroupRemoves.forEach(function (remove) {
            remove.addEventListener('click', function (evt) {
                evt.preventDefault();
                remove.closest('.item').remove();
            })
        });
    }

}

export {guarantee}
